/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timezone_Europe_Berlin2Inputs */

const he_timezone_europe_berlin2 = /** @type {(inputs: Timezone_Europe_Berlin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berlin`)
};

const en_timezone_europe_berlin2 = /** @type {(inputs: Timezone_Europe_Berlin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berlin`)
};

/**
* | output |
* | --- |
* | "Berlin" |
*
* @param {Timezone_Europe_Berlin2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const timezone_europe_berlin2 = /** @type {((inputs?: Timezone_Europe_Berlin2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timezone_Europe_Berlin2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_timezone_europe_berlin2(inputs)
	return en_timezone_europe_berlin2(inputs)
});
export { timezone_europe_berlin2 as "timezone_Europe_Berlin" }